import React from 'react'

export default function CallToActionBand() {
  return (
    <section className="home-cta-band" aria-labelledby="home-cta-title">
      <div className="home-cta-band__content">
        <p className="home-cta-band__eyebrow">Oportunidades para tu red</p>
        <h2 id="home-cta-title">¿Listo para mover tu carga?</h2>
        <p className="home-cta-band__subtitle">
          Activa cotizaciones en minutos y vincula tu operación con operadores verificados.
        </p>
        <a className="home-cta-band__button" href="/registro">
          Comenzar ahora
        </a>
      </div>
    </section>
  )
}
